import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-access-overlay"
}
const _hoisted_2 = {
  key: 0,
  class: "not-found-screen"
}
const _hoisted_3 = {
  key: 0,
  class: "not-found-signed-in"
}
const _hoisted_4 = {
  key: 1,
  class: "no-access-modal"
}
const _hoisted_5 = {
  key: 0,
  width: "32",
  height: "32",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_6 = {
  key: 1,
  width: "32",
  height: "32",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = { class: "modal-message" }
const _hoisted_9 = {
  key: 0,
  class: "signed-in-as"
}
const _hoisted_10 = { class: "modal-actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_13 = {
  key: 1,
  class: "spinner"
}

import { ref, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useUserStore } from '@/store/userStore';
import { useAccessStore } from '@/store/accessStore';
import { requestJoin } from '@/api/project';
import { hapticModal, haptic } from '@/utils/haptics';


export default /*@__PURE__*/_defineComponent({
  __name: 'NoAccessModal',
  props: {
    show: { type: Boolean },
    message: {},
    isNewProject: { type: Boolean },
    projectId: {}
  },
  emits: ["close", "accessRequested"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable */
const props = __props;

const emit = __emit;

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();
const accessStore = useAccessStore();

const requestSent = ref(false);
const requesting = ref(false);

// Duolingo-style: haptic feedback when modal appears
watch(() => props.show, (val) => {
  if (val) hapticModal();
});

const isSignedIn = computed(() => !!userStore.idToken);
const userEmail = computed(() => userStore.user?.email || '');

function goToSignIn() {
  const currentPath = route.fullPath;
  // Don't redirect back to auth pages (avoid redirect loops)
  const isAuthPath = currentPath.startsWith('/auth') || currentPath.startsWith('/p1/auth');
  if (isAuthPath) {
    router.push('/auth');
  } else {
    router.push({ path: '/auth', query: { redirect: currentPath } });
  }
  emit('close');
}

function goToProjects() {
  router.push('/projects');
  emit('close');
}

async function handleRequestAccess() {
  if (!props.projectId || requesting.value) return;

  requesting.value = true;
  try {
    const success = await requestJoin(props.projectId);
    if (success) {
      haptic('success');
      requestSent.value = true;
      emit('accessRequested');
    }
  } finally {
    requesting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_unref(accessStore).notFound)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "not-found-code" }, "404", -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "not-found-title" }, "Project not found", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "not-found-desc" }, [
                      _createTextVNode(" This project doesn't exist or the link may be broken."),
                      _createElementVNode("br"),
                      _createTextVNode(" Check the URL and try again. ")
                    ], -1)),
                    _createElementVNode("div", { class: "not-found-actions" }, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: goToProjects
                      }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("svg", {
                          width: "18",
                          height: "18",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }),
                          _createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" })
                        ], -1),
                        _createTextVNode(" Go to My Projects ", -1)
                      ]))])
                    ]),
                    (userEmail.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                          _cache[1] || (_cache[1] = _createTextVNode(" Signed in as ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(userEmail.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "modal-bg-decoration" }, null, -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["modal-icon", { 'icon-success': requestSent.value }])
                    }, [
                      (!requestSent.value)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "11",
                              width: "18",
                              height: "11",
                              rx: "2",
                              ry: "2"
                            }, null, -1),
                            _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("path", { d: "M20 6L9 17l-5-5" }, null, -1)
                          ]))]))
                    ], 2),
                    _createElementVNode("h2", _hoisted_7, [
                      (requestSent.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Request Sent!")
                          ], 64))
                        : (_ctx.isNewProject)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Almost There!")
                            ], 64))
                          : (!isSignedIn.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode("Sign In Required")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createTextVNode("Request Access")
                              ], 64))
                    ]),
                    _createElementVNode("p", _hoisted_8, [
                      (requestSent.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" Your request has been sent to the project owner. You'll be notified when they respond. ")
                          ], 64))
                        : (_ctx.isNewProject)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" Sign in to continue with your newly-created project. ")
                            ], 64))
                          : (!isSignedIn.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(" Sign in to view this project or request access from the owner. ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createTextVNode(_toDisplayString(_ctx.message ||
                "You don't have permission to view this project. Request access from the owner.") + " ", 1),
                                (userEmail.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                      _cache[7] || (_cache[7] = _createTextVNode(" Signed in as ", -1)),
                                      _createElementVNode("strong", null, _toDisplayString(userEmail.value), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (requestSent.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary",
                            onClick: goToProjects
                          }, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("svg", {
                              width: "18",
                              height: "18",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }),
                              _createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" })
                            ], -1),
                            _createTextVNode(" Go to My Projects ", -1)
                          ]))]))
                        : (!isSignedIn.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-primary",
                              onClick: goToSignIn
                            }, " Sign In "))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: handleRequestAccess,
                                disabled: requesting.value
                              }, [
                                (!requesting.value)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[9] || (_cache[9] = [
                                      _createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }, null, -1),
                                      _createElementVNode("circle", {
                                        cx: "8.5",
                                        cy: "7",
                                        r: "4"
                                      }, null, -1),
                                      _createElementVNode("line", {
                                        x1: "20",
                                        y1: "8",
                                        x2: "20",
                                        y2: "14"
                                      }, null, -1),
                                      _createElementVNode("line", {
                                        x1: "23",
                                        y1: "11",
                                        x2: "17",
                                        y2: "11"
                                      }, null, -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                (requesting.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(requesting.value ? 'Sending...' : 'Request Access'), 1)
                              ], 8, _hoisted_11),
                              _createElementVNode("button", {
                                class: "btn btn-secondary",
                                onClick: goToProjects
                              }, [...(_cache[10] || (_cache[10] = [
                                _createElementVNode("svg", {
                                  width: "18",
                                  height: "18",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2"
                                }, [
                                  _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }),
                                  _createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" })
                                ], -1),
                                _createTextVNode(" My Projects ", -1)
                              ]))])
                            ], 64))
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})